var accordions = document.querySelectorAll('.accordion__item--pc');
var sidebar = document.querySelector('.accordion-sidebar');
var sidebarClose = document.querySelector('.accordion-sidebar-close')
if(sidebar) {
    for(const accordion of accordions) {
        accordion.addEventListener('click', function(){
            var title = accordion.querySelector('.accordion__trigger').innerHTML;
            var content = accordion.querySelector('.accordion__content').innerHTML;
            document.getElementById('sidebarTitle').innerHTML = title;
            document.getElementById('sidebarContent').innerHTML = content;
            sidebar.classList.add('active');
        });
    }

    sidebarClose.addEventListener('click', function(){
        sidebar.classList.remove('active');
    });

    document.addEventListener('click', function(e){
        if(sidebar.classList.contains('active')) {
            if(e.target.classList.contains('active')) {
                sidebar.classList.remove('active');
            }
        } else {
        }
    })
}

(function () {
    var ACCESS_TOKEN = '74581e11c2481afe9c5efb3ba2bf344a';
    var productMetaCache = new Map();
    var hydrateTimeout = null;
    var isHydrating = false;
    var miniCartNoteTimeout = null;

    function isDescriptionNode(node) {
        return !!(
            node &&
            node.nodeType === 1 &&
            node.classList &&
            (
                node.classList.contains('mini-cart-item__info-short-description') ||
                node.classList.contains('mini-cart-item__info-sample-meta')
            )
        );
    }

    function isRelevantMiniCartNode(node) {
        return !!(node && node.nodeType === 1 && (node.matches('.mini-cart, .mini-cart-item') || node.querySelector('.mini-cart, .mini-cart-item')));
    }

    function getHandleFromUrl(url) {
        try {
            var parsed = new URL(url, window.location.origin);
            var parts = parsed.pathname.split('/').filter(Boolean);
            var productsIndex = parts.indexOf('products');
            return productsIndex >= 0 ? parts[productsIndex + 1] || '' : '';
        } catch (error) {
            return '';
        }
    }

    function getHandleFromItem(item) {
        if (!item) {
            return '';
        }

        var handleFromData = item.getAttribute('data-product-handle');
        if (handleFromData) {
            return handleFromData;
        }

        var title = getTitleLink(item);
        return title ? getHandleFromUrl(title.href) : '';
    }

    function getProductIdFromItem(item) {
        if (!item) {
            return '';
        }

        return item.getAttribute('data-product-id') || '';
    }

    function getTitleLink(item) {
        return item.querySelector('.mini-cart-item__info-title[href]');
    }

    function isSampleItem(item) {
        return !!(item && item.classList && item.classList.contains('mini-cart-item--sample'));
    }

    // Subtitles rendered by sections/mini-cart.liquid. These cover every cart product, whereas the
    // Storefront API below only sees products published to its token's sales channel.
    function readRenderedProductMeta(productId) {
        var script = document.querySelector('.mini-cart [data-mini-cart-product-meta]');
        if (!script || !productId) {
            return null;
        }

        try {
            var entry = JSON.parse(script.textContent)[productId];
            return entry ? {
                shortDescription: entry.shortDescription || '',
                altTitle: entry.altTitle || '',
                url: entry.url || ''
            } : null;
        } catch (error) {
            return null;
        }
    }

    async function fetchProductMeta(handle, productId) {
        if (!handle && !productId) {
            return {
                shortDescription: '',
                altTitle: '',
                url: ''
            };
        }

        var cacheKey = handle ? 'handle:' + handle : 'id:' + productId;
        if (productMetaCache.has(cacheKey)) {
            return productMetaCache.get(cacheKey);
        }

        var query = handle
            ? '{ productByHandle(handle: ' + JSON.stringify(handle) + ') { handle onlineStoreUrl shortDescription: metafield(namespace: "description", key: "short") { value } altTitle: metafield(namespace: "alt", key: "title") { value } } }'
            : '{ product(id: ' + JSON.stringify('gid://shopify/Product/' + productId) + ') { ... on Product { handle onlineStoreUrl shortDescription: metafield(namespace: "description", key: "short") { value } altTitle: metafield(namespace: "alt", key: "title") { value } } } }';

        try {
            var response = await fetch('/api/2023-10/graphql.json', {
                credentials: 'include',
                method: 'post',
                headers: {
                    'Content-Type': 'application/graphql',
                    'X-Shopify-Storefront-Access-Token': ACCESS_TOKEN
                },
                body: query
            });
            var data = await response.json();
            var product = data && data.data ? (handle ? data.data.productByHandle : data.data.product) : null;
            var meta = {
                shortDescription: product && product.shortDescription ? product.shortDescription.value || '' : '',
                altTitle: product && product.altTitle ? product.altTitle.value || '' : '',
                url: product && product.onlineStoreUrl ? product.onlineStoreUrl : (product && product.handle ? '/products/' + product.handle : '')
            };

            productMetaCache.set(cacheKey, meta);
            if (handle && productId) {
                productMetaCache.set('id:' + productId, meta);
            }
            return meta;
        } catch (error) {
            var emptyMeta = {
                shortDescription: '',
                altTitle: '',
                url: ''
            };

            productMetaCache.set(cacheKey, emptyMeta);
            return emptyMeta;
        }
    }

    function renderShortDescription(item, meta) {
        var content = item.querySelector('.mini-cart-item__info-content');
        var title = getTitleLink(item);
        if (!content || !title) {
            return;
        }

        var description = meta && meta.shortDescription ? meta.shortDescription : '';
        var altTitle = meta && meta.altTitle ? meta.altTitle : '';
        var url = meta && meta.url ? meta.url : '';
        var existing = content.querySelector('.mini-cart-item__info-short-description');
        var sampleMeta = content.querySelector('.mini-cart-item__info-sample-meta');
        var sampleItem = isSampleItem(item);

        if (altTitle && title.textContent !== altTitle) {
            title.textContent = altTitle;
            title.setAttribute('title', altTitle);
        }

        if (url && title.getAttribute('href') !== url) {
            title.setAttribute('href', url);
        }

        var imageLink = item.querySelector('.mini-cart-item__image[href]');
        if (imageLink && url && imageLink.getAttribute('href') !== url) {
            imageLink.setAttribute('href', url);
            imageLink.setAttribute('title', altTitle || title.textContent || '');
        }

        if (sampleItem && ((existing && existing.textContent.trim()) || (sampleMeta && sampleMeta.textContent.trim()))) {
            return;
        }

        if (!description) {
            if (existing) {
                existing.remove();
            }
            if (sampleMeta) {
                sampleMeta.remove();
            }
            return;
        }

        if (!existing) {
            existing = document.createElement('div');
            existing.className = 'mini-cart-item__info-short-description';
            title.insertAdjacentElement('afterend', existing);
        }

        if (existing.textContent !== description) {
            existing.textContent = description;
        }

        if (sampleMeta) {
            sampleMeta.remove();
        }
    }

    async function hydrateMiniCartDescriptions() {
        if (isHydrating) {
            return;
        }
        isHydrating = true;
        var items = Array.prototype.slice.call(document.querySelectorAll('.mini-cart .mini-cart-item'));
        try {
            await Promise.all(items.map(async function (item) {
                var handle = getHandleFromItem(item);
                var productId = getProductIdFromItem(item);
                var meta = readRenderedProductMeta(productId) || await fetchProductMeta(handle, productId);
                renderShortDescription(item, meta);
            }));
        } finally {
            isHydrating = false;
        }
    }

    function queueHydration() {
        clearTimeout(hydrateTimeout);
        hydrateTimeout = setTimeout(function () {
            hydrateMiniCartDescriptions();
        }, 50);
    }

    var observer = new MutationObserver(function (mutations) {
        if (isHydrating) {
            return;
        }
        for (var i = 0; i < mutations.length; i += 1) {
            var mutation = mutations[i];
            var addedNodes = Array.prototype.slice.call(mutation.addedNodes || []);
            var removedNodes = Array.prototype.slice.call(mutation.removedNodes || []);
            var hasRelevantAddition = addedNodes.some(function (node) {
                return !isDescriptionNode(node) && isRelevantMiniCartNode(node);
            });
            var hasRelevantRemoval = removedNodes.some(function (node) {
                return !isDescriptionNode(node) && isRelevantMiniCartNode(node);
            });
            if (hasRelevantAddition || hasRelevantRemoval) {
                queueHydration();
                return;
            }
        }
    });

    if (document.body) {
        observer.observe(document.body, {
            childList: true,
            subtree: true
        });
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', queueHydration);
    } else {
        queueHydration();
    }

    function isMiniCartNoteField(target) {
        return !!(target && target.matches && target.matches('.mini-cart textarea[name="note"]'));
    }

    function findGiftNote(target) {
        return target && target.closest ? target.closest('[data-gift-note]') : null;
    }

    function getGiftNoteText(textarea) {
        return textarea && typeof textarea.value === 'string' ? textarea.value.replace(/\r\n/g, '\n').trim() : '';
    }

    function updateGiftNoteCount(textarea) {
        if (!textarea) {
            return;
        }

        var giftNote = findGiftNote(textarea);
        var count = giftNote ? giftNote.querySelector('[data-gift-note-count]') : null;

        if (!count) {
            return;
        }

        var maxLength = parseInt(textarea.getAttribute('maxlength'), 10) || 300;
        var currentLength = typeof textarea.value === 'string' ? textarea.value.length : 0;

        count.textContent = currentLength + ' / ' + maxLength;
    }

    function setGiftNoteState(giftNote, options) {
        if (!giftNote) {
            return;
        }

        var textarea = giftNote.querySelector('[data-gift-note-textarea]');
        var message = giftNote.querySelector('[data-gift-note-message]');
        var checkbox = giftNote.querySelector('.gift-options__note-checkbox');
        var hasNote = typeof options.hasNote === 'boolean' ? options.hasNote : giftNote.dataset.hasNote === 'true';
        var expanded = typeof options.expanded === 'boolean' ? options.expanded : giftNote.dataset.expanded === 'true';
        var noteText = typeof options.noteText === 'string' ? options.noteText : getGiftNoteText(textarea);

        giftNote.dataset.hasNote = hasNote ? 'true' : 'false';
        giftNote.dataset.expanded = checkbox && checkbox.checked && expanded ? 'true' : 'false';

        if (message) {
            message.textContent = hasNote ? noteText : '';
        }

        updateGiftNoteCount(textarea);
    }

    function toggleGiftNoteFromCheckbox(checkbox) {
        var giftNote = findGiftNote(checkbox);

        if (!giftNote) {
            return;
        }

        setGiftNoteState(giftNote, {
            expanded: !!checkbox.checked && giftNote.dataset.hasNote !== 'true'
        });
    }

    function updateMiniCartNote(target) {
        var miniCart = target && target.closest ? target.closest('.mini-cart') : null;
        if (!miniCart) {
            return;
        }

        miniCart.classList.add('mini-cart--loading');

        fetch((window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                note: target.value
            })
        }).catch(function (error) {
            console.error(error);
        }).finally(function () {
            miniCart.classList.remove('mini-cart--loading');
        });
    }

    document.addEventListener('change', function (event) {
        if (event.target && event.target.matches && event.target.matches('.gift-options__note-checkbox')) {
            toggleGiftNoteFromCheckbox(event.target);
        }

        if (!isMiniCartNoteField(event.target)) {
            return;
        }

        clearTimeout(miniCartNoteTimeout);
        updateMiniCartNote(event.target);
    });

    document.addEventListener('input', function (event) {
        if (event.target && event.target.matches && event.target.matches('[data-gift-note-textarea]')) {
            updateGiftNoteCount(event.target);
        }

        if (!isMiniCartNoteField(event.target)) {
            return;
        }

        clearTimeout(miniCartNoteTimeout);
        miniCartNoteTimeout = setTimeout(function () {
            updateMiniCartNote(event.target);
        }, 1000);
    });

    document.addEventListener('click', function (event) {
        var confirmButton = event.target && event.target.closest ? event.target.closest('[data-gift-note-confirm]') : null;
        var editButton = event.target && event.target.closest ? event.target.closest('[data-gift-note-edit]') : null;

        if (confirmButton) {
            event.preventDefault();
            event.stopPropagation();
            event.stopImmediatePropagation();

            var giftNote = findGiftNote(confirmButton);
            var textarea = giftNote ? giftNote.querySelector('[data-gift-note-textarea]') : null;
            var noteText = getGiftNoteText(textarea);

            setGiftNoteState(giftNote, {
                expanded: false,
                hasNote: noteText.length > 0,
                noteText: noteText
            });

            if (isMiniCartNoteField(textarea)) {
                clearTimeout(miniCartNoteTimeout);
                updateMiniCartNote(textarea);
            }

            return;
        }

        if (!editButton) {
            return;
        }

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        var editableGiftNote = findGiftNote(editButton);
        var editableTextarea = editableGiftNote ? editableGiftNote.querySelector('[data-gift-note-textarea]') : null;

        setGiftNoteState(editableGiftNote, {
            expanded: true
        });

        if (editableTextarea) {
            editableTextarea.focus();
            editableTextarea.setSelectionRange(editableTextarea.value.length, editableTextarea.value.length);
        }
    }, true);
})();